export default __webpack_public_path__ + "static/esg-chart-desktop-75e90230bbe1a9a021c78f811e57b4d8.png";